var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-footer", attrs: { align: "center" } }, [
    _c("div", { staticClass: "page-footer-inner" }, [
      _c("div", [
        _vm._v(
          "Copyright © 2007 - " +
            _vm._s(_vm.getCurrentYear()) +
            " Buy1Give1 Pte Ltd/B1G1 Giving Inc"
        )
      ])
    ]),
    _vm._v(" "),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "social-icon-footer" }, [
      _c("a", {
        staticClass: "fa fa-facebook fa-2x",
        attrs: { href: "https://www.facebook.com/b1g1giving", target: "_blank" }
      }),
      _vm._v(" "),
      _c("a", {
        staticClass: "fa fa-x-twitter fa-2x",
        attrs: { href: "https://twitter.com/B1G1", target: "_blank" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d5fc5f2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d5fc5f2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partner/Footer.vue
// module id = null
// module chunks = 